export default __webpack_public_path__ + "static/media/big-sized-wallet.a2fd2646.png";